import {Routes} from '@angular/router';
import {AuthGuard} from '../components/security/authorization/auth.guard';
import loginPageRoutes from './login/login-page.routing';
import registerPageRoutes from './register/register-page.routing';
import accountPageRoutes from './account/account-page.routing';
import adminPagesRoutes from './admin/admin-pages.routing';
import cvPagesRoutes from './cv/cv-pages.routing';
import ocrRoutes from './resume/resume-pages.routing';
import releasePageRoutes from './release/release-page.routing';
import dashboardPageRoutes from './dashboard/dashboard-page.routing';
import personalDetailsPageRoutes from './personal-details/personal-details-page.routing';
import educationPageRoutes, {screenManagers as educationScreensManagerProviders} from './education/education-page.routing';
import workPageRoutes, {screenManagers as workScreensManagerProviders} from './work/work-page.routing';
import licensesCertificationsPageRoutes, {screenManagers as licensesCertificationsScreensManagerProviders} from './licenses-certifications/licenses-certifications-page.routing';
import professionalLiabilityPageRoutes from './liability/professional-liability-page.routing';
import referencesPageRoutes, {screenManagers as referenceScreensManagerProviders} from './references/references-page.routing';
import documentsPageRoutes from './documents/documents-pages.routing';
import verificationSummaryRoutes from './verification/verification-summary.routing';
import notesPageRoutes from './notes/notes-pages.routing';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
export const screenManagerProviders = (
    <any[]>educationScreensManagerProviders)
    .concat(workScreensManagerProviders,
        licensesCertificationsScreensManagerProviders,
        referenceScreensManagerProviders);

export let rootRoutes: Routes = [{
    path: '',
    canActivateChild: [AuthGuard],
    children: (<Routes>[
        {path: '', redirectTo: '/dashboard', pathMatch: 'full', data: {withSectionNav: false}},
    ]).concat(
        loginPageRoutes,
        registerPageRoutes,
        accountPageRoutes,
        adminPagesRoutes,
        cvPagesRoutes,
        ocrRoutes,
        dashboardPageRoutes,
        personalDetailsPageRoutes,
        educationPageRoutes,
        workPageRoutes,
        licensesCertificationsPageRoutes,
        professionalLiabilityPageRoutes,
        referencesPageRoutes,
        releasePageRoutes,
        documentsPageRoutes,
        verificationSummaryRoutes,
        notesPageRoutes,
    )
}];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/page-content.routing.ts